module.exports = __webpack_public_path__ + "c3f6df0d75256ba2d9d60e110fd8277a.pdf";